"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExerciseControls = void 0;
const Button_1 = __importStar(require("@app/routes/SpeechDevelopment/components/Button"));
const translations_1 = require("@app/routes/SpeechDevelopment/translations");
const menuBarExercise_1 = __importDefault(require("@components/menuBar/menuBarExercise"));
const react_1 = __importDefault(require("react"));
const helpers_1 = require("@app/helpers");
function ExerciseControls({ currentCardIndex, canLeaf, isPaused, isStarted, handleStart, handleEndExercise, handlePause, handleNext, handlePrev, isLast, }) {
    const langId = (0, helpers_1.getCurrentLanguage)();
    return (react_1.default.createElement(menuBarExercise_1.default, null,
        react_1.default.createElement(Button_1.ButtonContainerWrapper, null,
            react_1.default.createElement(Button_1.default, { label: '←', disabled: currentCardIndex === 0 || !canLeaf, onClick: handlePrev }),
            react_1.default.createElement(Button_1.default, { showBlick: true, label: (0, translations_1.getLabelPauseButton)(langId, !isPaused, isStarted), isStarted: isStarted, onClick: isStarted ? handleEndExercise : handleStart, isCheckButton: false }),
            react_1.default.createElement(Button_1.default, { label: !isPaused ? '❚ ❚' : '▶', onClick: !isPaused ? handlePause : handleStart, disabled: !isStarted || !canLeaf, color: !isPaused ? '#F2A000' : null }),
            react_1.default.createElement(Button_1.default, { label: '→', disabled: isLast || !isStarted || !canLeaf, onClick: handleNext }))));
}
exports.ExerciseControls = ExerciseControls;
